import { forwardRef, type SVGProps } from 'react';

export interface MirrorVerticalAxisIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const MirrorVerticalAxisIcon = forwardRef<SVGSVGElement, MirrorVerticalAxisIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 18 20">
    <path
      d="M8.375 18.75V1.25C8.375.905 8.655.625 9 .625 9.345.625 9.625.905 9.625 1.25V18.75C9.625 19.095 9.345 19.375 9 19.375 8.655 19.375 8.375 19.095 8.375 18.75ZM6 5.875C6.162 5.66 6.443 5.572 6.698 5.657 6.953 5.742 7.125 5.981 7.125 6.25V13.75C7.125 14.095 6.845 14.375 6.5 14.375H.875C.638 14.375.422 14.241.316 14.029.21 13.818.233 13.564.375 13.375L6 5.875ZM2.124 13.125H5.875V8.124L2.124 13.125ZM11.302 5.657C11.558 5.572 11.839 5.66 12 5.875L17.625 13.375C17.767 13.564 17.79 13.818 17.684 14.029 17.578 14.241 17.362 14.375 17.125 14.375H11.5C11.155 14.375 10.875 14.095 10.875 13.75V6.25C10.875 5.981 11.047 5.742 11.302 5.657ZM12.125 13.125H15.876L12.125 8.124V13.125Z"
      fill="currentColor"
    />
  </svg>
));

MirrorVerticalAxisIcon.displayName = 'MirrorVerticalAxisIcon';
